<template>
<a class="gi-card" :href="data.link" target="_blank">
  <div class="image"><img :src="data['图片']"></div>
  <div class="content">
    <h1 class="title">{{data.title}}</h1>
    <p class="intro">{{data.description}}</p>
    <p class="tip">{{data.tip}}</p>
  </div>
</a>
</template>

<script>
export default {
  props: ['data']
}
</script>

<style lang="sass">
$title-primary: #1075d4

=mobile
  @media screen and (max-width: 768px)
    @content

=tablet
  @media screen and (min-width: 769px)
    @content

a.gi-card:hover
  opacity: 0.8
.gi-card
  display: block
  border: 1px solid #ccc
  img
    width: 100%
    border-bottom: 1px solid #ccc
  .content
    background-color: #fff
    padding: 15px
  h1
    font-size: 18px
    color: #000
    +mobile
      font-size: 16px
  p
    margin-top: 5px
    font-size: 14px
  .tip
    margin-top: 20px
    font-size: 12px
    +mobile
      margin-top: 15px
</style>



// WEBPACK FOOTER //
// src/components/card/card.vue